// extracted by mini-css-extract-plugin
export default {"title":"AppBar_title__4qkr-","container":"AppBar_container__lWKTU","logo":"AppBar_logo__PcOIQ","back":"AppBar_back__vVeKx"};